import {
  Box,
  Button,
  Spinner,
  HStack,
  Text,
  IconButton,
  Input,
  useDisclosure,
  FormControl,
  InputRightElement,
  InputGroup,
  FormErrorMessage,
  Tag,
} from "@chakra-ui/react";
import colors from "resources/theme/colors";
import { RiPencilFill, RiCloseCircleLine } from "react-icons/ri";
import EditarPlanoModal from "./EditarPlanoModal";
import useInsertFinancialCategory from "features/condominio/hooks/useInsertFinancialCategory";
import { showError, showConfirm, showSuccess } from "infra/helpers/alerta";
import useDeleteFinancialCategory from "features/condominio/hooks/useDeleteFinancialCategory";
import { CategoriaFinanceiraItem } from "features/condominio/hooks/useListFinancialCategory";
import { useForm } from "react-hook-form";
import useUpdateFinancialCategory from "features/condominio/hooks/useUpdateFinancialCategory";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { FormFields } from "../index";

export function NodeItem({
  data,
  parent,
  actionInative,
}: {
  data: CategoriaFinanceiraItem;
  parent?: CategoriaFinanceiraItem;
  actionInative: boolean;
}) {
  const { tenant } = useCurrentTenant();

  const { mutate: deleteMutate, isLoading: isDeleting } =
    useDeleteFinancialCategory();
  const { register, handleSubmit, formState } = useForm<FormFields>({
    mode: "onBlur",
    shouldFocusError: false,
    // resolver: yupResolver(scheme),
  });
  const { mutate: updateMutate, isLoading: isUpdating } =
    useUpdateFinancialCategory(tenant.id);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { mutate: insertMutate } = useInsertFinancialCategory();
  const onSubmit = (postData: { nome: string }) => {
    const updated = {
      ...data,
      ...postData,
      categoriaFinanceiraPaiId: parent?.id,
    } as CategoriaFinanceiraItem;

    if (!isUpdating || !isDeleting) {
      updateMutate(updated);
    }
  };

  const onBlur = (postData: { nome?: string }) => {
    if (!postData.nome) {
      deleteMutate(data);
    }
  };

  const categoriaNaoEditavel =
    data.breadcrumb?.length === 1 ||
    (!parent && data.items?.length) ||
    data.readOnly ||
    !data.breadcrumb;

  const categoriaNaoExcluivel =
    data.breadcrumb?.length === 1 ||
    (!parent && data.items?.length) ||
    data.readOnly;

  return (
    <>
      {isOpen && (
        <EditarPlanoModal
          onClose={onClose}
          visible={isOpen}
          defaultCategoria={data}
        />
      )}
      <Box w="100%">
        <HStack
          h={"32px"}
          py="2px"
          w="100%"
          flexWrap="nowrap"
          alignItems="center"
          sx={{
            ".actions-stack": { display: isDeleting ? "flex" : "none" },
            "&:hover": {
              ".actions-stack": {
                display: "flex",
              },
            },
          }}
        >
          {data.nome ? (
            <Text
              minW={(data.breadcrumb + data.nome).length + 2 + "ch"}
              wordBreak="keep-all"
              textDecoration={data.ativo ? undefined : "line-through"}
              opacity={data.ativo ? undefined : 0.9}
            >
              {data.breadcrumb} - {data.nome} {}
            </Text>
          ) : (
            <HStack
              as="form"
              mr={2}
              onSubmit={handleSubmit(onSubmit)}
              onBlur={handleSubmit(onBlur)}
            >
              <Text>{data.breadcrumb}-</Text>
              <FormControl
                minW={"6rem"}
                id="nome"
                isInvalid={!!formState.errors?.nome}
              >
                <InputGroup alignItems="center" display="flex">
                  <Input size="sm" {...register("nome")} autoFocus />

                  {isUpdating && (
                    <InputRightElement
                      h="100%"
                      alignItems="center"
                      display="flex"
                    >
                      <Spinner size="xs" />
                    </InputRightElement>
                  )}
                </InputGroup>
                <FormErrorMessage mt={0}>
                  {formState.errors?.nome?.message}
                </FormErrorMessage>
              </FormControl>
            </HStack>
          )}
          {data.centroDeCusto ? (
            <Tag colorScheme="gray" size="sm">
              {data.centroDeCusto.nome}
            </Tag>
          ) : null}
          {!actionInative ? (
            <HStack spacing=".2rem" h={"24px"} className="actions-stack">
              <Button
                size="xs"
                variant="outline"
                color={colors.primary}
                borderColor={colors.primary}
                onClick={() => {
                  if (parent?.items?.length) {
                    if (!parent.items[0].nome) {
                      return showError("Registro anterior inválido!");
                    }
                  }
                  if (data.items?.length) {
                    if (!data.items[0].nome) {
                      return showError("Registro anterior inválido!");
                    }
                  }

                  insertMutate({ ...data, ativo: true } as any);
                }}
              >
                + Subcategoria
              </Button>
              {!categoriaNaoEditavel ? (
                <IconButton
                  size="sm"
                  color={colors.primary}
                  icon={<RiPencilFill />}
                  onClick={onOpen}
                  aria-label="editar"
                  bg="transparent"
                />
              ) : null}
              {!categoriaNaoExcluivel ? (
                <IconButton
                  size="sm"
                  color="red"
                  icon={<RiCloseCircleLine />}
                  aria-label="excluir"
                  onClick={() => {
                    if (data.items?.length) {
                      return showError(
                        "Não é possível excluir esta categoria. Exclua os itens filhos e tente novamente!"
                      );
                    }
                    showConfirm(
                      `Deseja realmente excluir a categoria ${data.breadcrumb} - ${data.nome}?`
                    ).then(({ isConfirmed }) => {
                      if (isConfirmed) {
                        deleteMutate(data, {
                          onSuccess: () => {
                            if (data.id) showSuccess();
                          },
                        });
                      }
                    });
                  }}
                  isLoading={isDeleting}
                  bg="transparent"
                />
              ) : null}
            </HStack>
          ) : null}
        </HStack>
      </Box>
    </>
  );
}
